import React from "react";
import PropTypes from "prop-types";
import Icon from "../../../atoms/icon";
import styles from "./styles.m.css";

const AppLinks = ({ appStoreLinks, className }) => {
  const AppStoreIcons = {
    "play-store": <Icon type={"android-small"} className={`${styles["app-links"]} ${styles["play-store"]}`} />,
    "app-store": <Icon type={"ios-small"} className={`${styles["app-links"]} ${styles["app-store"]}`} />
  };
  return (
    <ul className={`${styles["app-icons"]} ${className}`}>
      {Object.keys(appStoreLinks).map(link => {
        return (
          appStoreLinks[link] && (
            <li key={link} className={styles["app-link-item"]}>
              <a
                aria-label={link}
                href={appStoreLinks[link]}
                target="_blank"
                rel="noopener  noreferrer"
                className={styles["app-link"]}
              >
                {AppStoreIcons[link]}
              </a>
            </li>
          )
        );
      })}
    </ul>
  );
};

AppLinks.propTypes = {
  appStoreLinks: PropTypes.shape({
    "play-store": PropTypes.string,
    "app-store": PropTypes.string
  }),
  className: PropTypes.string
};

export default AppLinks;
